import { Link } from 'react-router-dom'
import { Home, RefreshCw, AlertTriangle } from 'lucide-react'
import { Helmet } from 'react-helmet-async'
import { useAuth } from '../hooks/useAuth'
import { AppHeader } from '../components'

export default function ErrorPage() {
  const { user, isAuthenticated } = useAuth()
  
  const handleRefresh = () => {
    if (typeof window !== 'undefined') {
      window.location.reload()
    }
  }

  return (
    <>
      <Helmet>
        <title>Server Error - FWO Pilot Portal</title>
        <meta name="description" content="An internal server error occurred" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100">
        {/* Show navigation for authenticated users */}
        {isAuthenticated && user && <AppHeader />}

        <div className="flex items-center justify-center" style={{ minHeight: isAuthenticated ? 'calc(100vh - 4rem)' : '100vh' }}>
          <div className="max-w-md w-full mx-auto px-4">
            <div className="text-center">
            {/* Logo */}
            <div className="flex justify-center mb-6">
              <div className="bg-white p-4 rounded-full shadow-lg">
                <AlertTriangle className="h-12 w-12 text-red-500" />
              </div>
            </div>

            {/* Error Message */}
            <h1 className="text-6xl font-bold text-gray-900 mb-4">500</h1>
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">Server Error</h2>
            <p className="text-gray-600 mb-8">
              Something went wrong on our end. We're working to fix this issue.
            </p>

            {/* Action Buttons */}
            <div className="space-y-3">
              <button
                onClick={handleRefresh}
                className="inline-flex items-center justify-center w-full px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                <RefreshCw className="h-5 w-5 mr-2" />
                Try Again
              </button>
              
              {isAuthenticated ? (
                <Link
                  to="/dashboard"
                  className="inline-flex items-center justify-center w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <Home className="h-5 w-5 mr-2" />
                  Go to Dashboard
                </Link>
              ) : (
                <Link
                  to="/"
                  className="inline-flex items-center justify-center w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <Home className="h-5 w-5 mr-2" />
                  Go to Homepage
                </Link>
              )}
            </div>

            {/* Help Text */}
            <div className="mt-8 text-sm text-gray-500">
              <p>
                If this problem persists, please contact our support team.
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}